import styled from 'styled-components';
import { Card } from '../../../../../../CommonComponents/OPL/Card/Card';

interface WrapperProps {
  isDragging?: boolean;
}

export const Wrapper = styled(Card)<WrapperProps>(
  {
    display: 'flex',
    cursor: 'grab',
  },

  ({ isDragging, theme }) =>
    isDragging && {
      border: `1px solid ${theme.colors.primary['300']}`,
      background: theme.colors.primary['100'],
    },
);
